import { useState } from 'react'
import {
  DefaultTitle,
  FormContainer,
  PDFApplicationCard,
  Link,
  ApplicationBodyContainer,
  ApplicationBodyContent,
  ApplicationBodyFooter
} from '../../../components/application/defaultComponents'
import { FlexDiv } from 'src/components/application/formComponents/styles'
import StandardInput from '../../../components/basic/StandardInput'
import Button from 'src/components/basic/Button'
import { tlieSources } from 'src/constants/tlie'
import { api } from 'src/services/apiClient'
import { HiDownload } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { useRenewal } from 'src/context/renewal'

const PdfRenewal = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [isSendingEmail, setIsSendingEmail] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const { renewalData } = useRenewal()

  const handleSendEmail = async () => {
    setIsSendingEmail(true)
    try {
      const apiUrl = renewalData?.insuranceType === 'LAWYER' ? '/Renewals/SendPdfRenewal' : '/Renewals/judge/SendPdf'
      await api.post(`${apiUrl}?email=${email}`)
      alert(`An email was sent to ${email} with the renewal attached.`)
    } catch (_) { } finally {
      setIsSendingEmail(false)
    }
  }

  const handleDownloadRenewal = async () => {
    setIsDownloading(true)
    try {
      const apiUrl = renewalData?.insuranceType === 'LAWYER' ? '/Renewals/DownloadPdfRenewal' : '/Renewals/judge/DownloadPdfRenewal'
      const { data } = await api.post(apiUrl, {}, { responseType: 'blob' })
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'TLIE Renewal.pdf')
      link.click()
      window.URL.revokeObjectURL(url)
    } catch (_) { } finally {
      setIsDownloading(false)
    }
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Complete a PDF Renewal</DefaultTitle>
        <FormContainer maxWidth='100%'>
          <PDFApplicationCard>
            <p>
              These forms can be filled out in Adobe Reader,
              signed and saved without an additional editing program,
              and then emailed to TLIE at {' '}
              <Link href={`mailto:${tlieSources.applicationEmail}`}>{tlieSources.applicationEmail}</Link>.
            </p>
            <p>
              Forms must include a signature. Facsimilie and digital signatures
              are acceptable. You can fill out the forms on your computer,
              scan them after printing with a manual signature, or fill them out
              by hand. You can send completed forms to <Link>{tlieSources.applicationEmail}</Link>,
              fax them to <Link>{tlieSources.applicationFax}</Link> or send by regular mail.
            </p>
            <p>
              To get the best results with PDF forms,{' '}
              <Link href='https://get.adobe.com/br/reader/' rel="noreferrer noopener" target="_blank">click here</Link>
              {' '}to get the latest version of Adobe Reader. For more information on generating
              your own digital signature in Adobe Reader, {' '}
              <Link
                href='https://cufacilities.sites.clemson.edu/digitalSig.php'
                rel="noreferrer noopener"
                target="_blank"
              >
                click here
              </Link>
            </p>
          </PDFApplicationCard>
          <FlexDiv gap='14px' margin='32px 0 0 0'>
            <FlexDiv>
              <StandardInput
                label="Email Address"
                type="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </FlexDiv>
            <FlexDiv minWidth='250px' align='flex-end'>
              <Button
                variant="secondary"
                style={{ padding: '5px 36px' }}
                onClick={handleSendEmail}
                disabled={isSendingEmail}
              >
                Email me a renewal
              </Button>
            </FlexDiv>
          </FlexDiv>
          <FlexDiv margin='32px 0 0 0'>
            <Button
              variant='secondary'
              onClick={handleDownloadRenewal}
              disabled={isDownloading}
            >
              <HiDownload style={{ marginRight: '8px' }} />
              Download a Renewal
            </Button>
          </FlexDiv>
        </FormContainer>
      </ApplicationBodyContent>
      <ApplicationBodyFooter>
        <Button prebuilt='back' onClick={() => { navigate('/customer/renew/type') }} />
        <Button prebuilt='returnTLIE' onClick={() => window.open(tlieSources.mainSiteUrl, '_self')} />
      </ApplicationBodyFooter>
    </ApplicationBodyContainer>
  )
}

export default PdfRenewal